import { ComparisonPageTemplate } from "@/components/ComparisonPageTemplate";
import { Brain, Users, Clock } from "lucide-react";

const CSWvsBrainscape = () => {
  return (
    <ComparisonPageTemplate
      platformName="Brainscape"
      platformUrl="https://www.brainscape.com"
      seoDescription="Compare CSW and Brainscape flashcard apps. Discover why CSW offers collaborative study without expensive subscriptions."
      seoKeywords="CSW vs Brainscape, Brainscape alternative, free flashcard app, confidence-based learning"
      canonicalUrl="https://csw.live/flash-cards/csw-vs-brainscape/"
      heroDescription="Looking for a Brainscape alternative without the high subscription cost? CSW offers collaborative study and gamified learning—all for free."
      alternativeDescription="While Brainscape offers confidence-based learning, CSW provides a more accessible, social learning environment."
      background="Brainscape hosts user-created decks with a Confidence Scale for progress visualization and clean app experience."
      pros={[
        { text: "Large library of user-created decks" },
        { text: "Confidence Scale for progress visualization" },
        { text: "Clean app experience" }
      ]}
      cons={[
        { text: "Expensive subscriptions" },
        { text: "Premium required for full access" },
        { text: "Limited collaborative features" }
      ]}
      cswFeatures={[
        { text: "Unlimited Access", available: true },
        { text: "Collaborative Study", available: true },
        { text: "Gamified Learning", available: true },
        { text: "Free Full Features", available: true }
      ]}
      competitorFeatures={[
        { text: "Unlimited Access", available: false },
        { text: "Collaborative Study", available: false },
        { text: "Gamified Learning", available: false },
        { text: "Free Full Features", available: false }
      ]}
      benefits={[
        { icon: Brain, title: "Free Forever", description: "Access all features without subscriptions." },
        { icon: Users, title: "Study Together", description: "Collaborate with friends in real-time." },
        { icon: Clock, title: "Engaging Learning", description: "Gamified elements keep you motivated." }
      ]}
      forStudentsText="CSW provides everything Brainscape offers and more—without the expensive subscription fees."
      pricingText="Brainscape's premium features require costly subscriptions. CSW offers unlimited access free."
      competitorPrice="$9.99/month"
    />
  );
};

export default CSWvsBrainscape;
